module.exports = __webpack_public_path__ + "group-17.svg?78978deb9f57095f952fc428adbe949c";